import {
  LOAD_PRELIMINARY_EQUIPMENTS,
  LOAD_PRELIMINARY_EQUIPMENTS_BY_RACE,
} from './constants';

export function loadPreliminaryEquipments(round) {
  return {
    type: LOAD_PRELIMINARY_EQUIPMENTS,
    round,
  };
}

export function loadPreliminaryEquipmentsByRace(race) {
  return {
    type: LOAD_PRELIMINARY_EQUIPMENTS_BY_RACE,
    race,
  };
}
